const en = {
  message: {
    amountValidate: 'Amount should greater than 0',
  },
};

export default en;
